import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  DetachedRouteHandle,
  RouteReuseStrategy,
} from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class CustomRouteReuseStrategy implements RouteReuseStrategy {
  /** 再利用するルート用のストア */
  private routeStore = new Map<string, DetachedRouteHandle>();

  shouldDetach(route: ActivatedRouteSnapshot): boolean {
    return this.isReuse(route);
  }

  store(route: ActivatedRouteSnapshot, handle: DetachedRouteHandle): void {
    const path = this.getPathFromRoot(route);
    if (path) {
      this.routeStore.set(path, handle);
    }
  }

  shouldAttach(route: ActivatedRouteSnapshot): boolean {
    if (this.isReuse(route)) {
      const path = this.getPathFromRoot(route);
      return !!path && !!this.routeStore.get(path);
    }
    return false;
  }

  retrieve(route: ActivatedRouteSnapshot): DetachedRouteHandle | null {
    const path = this.getPathFromRoot(route);
    if (path) {
      return this.routeStore.get(path) ?? null;
    }
    return null;
  }

  shouldReuseRoute(
    future: ActivatedRouteSnapshot,
    curr: ActivatedRouteSnapshot
  ): boolean {
    return future.routeConfig === curr.routeConfig;
  }

  /**
   * 再利用するルート用のストアをクリアする。
   */
  refresh() {
    this.routeStore.clear();
  }

  /**
   * 再利用対象のRouteかどうかを判定する。
   * @param route 判定対象のRoute
   * @returns 再利用対象であればtrue、そうでなければfalse
   */
  private isReuse(route: ActivatedRouteSnapshot) {
    return (
      route.routeConfig &&
      route.routeConfig.data &&
      route.routeConfig.data['reuse']
    );
  }

  /**
   * ルートからのパス文字列を取得する。
   * @param route 取得対象のRoute
   * @returns ルートからのパス文字列
   */
  private getPathFromRoot(route: ActivatedRouteSnapshot): string | null {
    const url = route.pathFromRoot
      .filter((route) => route.url.length > 0)
      .map((route) => route.url.map((url) => url.path).join('/'))
      .join('/');
    return url.length > 0 ? url : null;
  }
}
